// frontend/src/components/Header/Header.js
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import Button from './Button';
import { ThemeContext } from '../context/ThemeContext';

function Header() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { theme, toggleTheme } = useContext(ThemeContext);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="header">
            <div className="container header-container">
                <div className="logo">
                    <Link to="/" className="logo-link">CryptoFinance</Link>
                </div>
                <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                    <ul>
                        <li><Link to="/exchange">Exchange</Link></li>
                        <li><Link to="/markets">Markets</Link></li>
                        <li><Link to="/news">News</Link></li>
                        <li><Link to="/support">Support</Link></li>
                        <li><Link to="/login"><Button className="login-btn">Login</Button></Link></li>
                        <li><Link to="/signup"><Button className="signup-btn">Sign Up</Button></Link></li>
                        <li>
                            <Button 
                                onClick={toggleTheme} 
                                className="theme-toggle-btn" 
                                aria-label="Toggle Dark Mode"
                            >
                                {theme === 'dark' ? '🌙' : '☀️'}
                            </Button>
                        </li>
                    </ul>
                </nav>
                <button 
                    className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`} 
                    onClick={toggleMobileMenu}
                    aria-label="Toggle navigation menu"
                    aria-expanded={isMobileMenuOpen}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>
            </div>
        </header>
    );
}

export default Header;
